import { Component, Input} from '@angular/core';
import { Platform} from 'ionic-angular';
import { RouteProvider } from '../../providers/route/route';
import { InAppBrowser } from '@ionic-native/in-app-browser'
import { APP_CONFIG, Region } from '../../environment';
import { TranslateService } from '@ngx-translate/core';
import { LocationProvider } from '../../providers/location/location';
@Component({
  selector: 'rmt-location-list-item',
  templateUrl: 'rmt-location-list-item.html'
})
export class RmtLocationListItem {
  @Input() location: any;
  distanceMetric: string = 'km'
  isOpen: boolean = false

  constructor(private routeProvider: RouteProvider,
              private platform: Platform,
              private iab: InAppBrowser,
              private locationProvider: LocationProvider,
              private translate: TranslateService) {
        if (APP_CONFIG.region.region === Region.US || APP_CONFIG.region.region === Region.UK) 
            this.distanceMetric = 'mi';
  }

  showDetail() {
    this.routeProvider.openActionSheet(this.routeProvider.pages.LocationDetailPage, { location: this.location, isOpen: this.isOpen, showBackdrop: false}, null, 'location-details-modal');
      return;
  }

  allClosed() {
    if(this.location.businessHours == null) {
      return true
    }

    for (let i = 0; i < this.location.businessHours.length; i++) {
      const currentBusinessHourData = this.location.businessHours[i];
      if(currentBusinessHourData.timeOpen == null || currentBusinessHourData.timeClose == null) {
        continue;
      } else {
        return false;
      }
    }
    return true;
  }

  getOpenOrClosedText() {
    if(this.location.businessHours == null) {
      return ``
    }
    const currentDay = this.getDayAsString()
    for (let i = 0; i < this.location.businessHours.length; i++) {
      var currentHour = this.location.businessHours[i]
      if(currentDay == currentHour.dayOfWeek) {
        if(currentHour.timeOpen != null || currentHour.timeClose != null) {
          if(this.isCurrentTimeInNotBetween(currentHour)) {
            this.isOpen = false
            return `${this.translate.instant('page.storeLocatorPage.closedLabel')}`
          } else {
            this.isOpen = true
            var hour = currentHour.timeClose.split(':')[0];
            var minute = currentHour.timeClose.split(':')[1];
            return `${this.translate.instant('page.storeLocatorPage.openUntilLabel')} ${hour}:${minute}`;
          }
        } else {
          this.isOpen = false
          return `${this.translate.instant('page.storeLocatorPage.closedLabel')}`
        }
      }
    }
    return ``
  }

  isCurrentTimeInNotBetween(currentBusinessHour) {
    var date = new Date()
    var openHour = currentBusinessHour.timeOpen.split(':')[0]
    var openMinute = currentBusinessHour.timeOpen.split(':')[1]

    var closeHour = currentBusinessHour.timeClose.split(':')[0]
    var closeMinute = currentBusinessHour.timeClose.split(':')[1]

    /* Hadnle possible NaN cases */
    if (this.isNumber(openHour) && this.isNumber(openMinute) && this.isNumber(closeHour) && this.isNumber(closeMinute)) {
      openHour = parseInt(openHour)
      openMinute = parseInt(openMinute)
      closeHour = parseInt(closeHour)
      closeMinute = parseInt(closeMinute)
    } else {
      return true
    }

    //Handle the 12 AM (i.e. 00:00) case
    if (closeHour == 0) {
      closeHour = 24
    }

    var currentHour = date.getHours()
    var currentMinute = date.getMinutes()

    if (currentHour > openHour && currentHour < closeHour) {
      return false
    } else if (currentHour == openHour && currentMinute >= openMinute) {
      return false
    } 
    else if (currentHour == closeHour && currentMinute <= closeMinute) {
      return false
    } 
    else {
      return true
    }
  }

  isNumber(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  getDayAsString() {
    var weekday=new Array(7);
      weekday[0]="Sunday";
      weekday[1]="Monday";
      weekday[2]="Tuesday";
      weekday[3]="Wednesday";
      weekday[4]="Thursday";
      weekday[5]="Friday";
      weekday[6]="Saturday";
      var date = new Date();
      var day = date.getDay();
      return weekday[day];
  }

  goToLocation() {
    let addressString = `${this.location.agentName},${this.location.agentLocName},${this.location.address.street},${this.location.address.city},${this.location.address.country}`;
    if (this.location.address.postalCode) {
      addressString += `,${this.location.address.postalCode}`;
    }

    this.locationProvider.openMapWithDirection(addressString);
  }
}


// WEBPACK FOOTER //
// ./src/components/rmt-location-list-item/rmt-location-list-item.ts